import { AxiosInstance } from 'axios';

export interface LambdaResponseMetadata {
    elapsedTime: number;
    lambda_execution_time: number;
    lambda_request_unit_cost: number;
    operationId: string;
}

export interface ExecuteLambdaResponse<DataResponse> {
    data: DataResponse;
    metadata: LambdaResponseMetadata;
}

export interface ExecuteLambdaParams<LambdaInputs extends {}> {
    clientId: string;
    lambdaId: string;
    lambdaInputs: LambdaInputs;
}

export interface ILambdaService {
    executeLambda<LambdaInputs extends {}, LambdaDataResponse extends {}>({
        clientId,
        lambdaId,
        lambdaInputs,
    }: ExecuteLambdaParams<LambdaInputs>): Promise<ExecuteLambdaResponse<LambdaDataResponse>>;
}

export default class LambdaService implements ILambdaService {
    constructor(private httpClient: AxiosInstance) {}

    async executeLambda<LambdaInputs extends {}, LambdaDataResponse extends {}>({
        clientId,
        lambdaId,
        lambdaInputs,
    }: {
        clientId: string;
        lambdaId: string;
        lambdaInputs: LambdaInputs;
    }): Promise<ExecuteLambdaResponse<LambdaDataResponse>> {
        if (!clientId) throw Error('Unable to execute lambda. Missing clientId');
        if (!lambdaId) throw Error(`Unable to execute lambda. Missing lambdaId for client ${clientId}`);
        if (!lambdaInputs) throw Error(`Unable to execute lambda. Missing lambda inputs for ${lambdaId}`);

        return await this.httpClient.post(`/lambda/clients/${clientId}/lambdas/${lambdaId}`, {
            lambda_inputs: lambdaInputs,
        });
    }
}
